import { jsx as n } from "react/jsx-runtime";
import { buildClassNames as d } from "../../style/build-class-names.mjs";
const m = (t, o) => {
  const a = parseInt(t, 16);
  return Number(a + o).toString(16);
}, g = "abcdefghijklmnopqrstuvwxyz", p = "1f1e6", r = g.split("").reduce((t, o, a) => ({
  ...t,
  // construct alphabet by incrementing A letter codepoint value
  [o]: m(p, a)
}), {}), u = (t) => [r[t[0]], r[t[1]]].join("-"), j = ({
  iso2: t,
  size: o = "24px",
  protocol: a = "https",
  disableLazyLoading: s,
  className: c,
  ...e
}) => {
  if (!t)
    return /* @__PURE__ */ n("img", { width: o, height: o, ...e });
  const i = u(t), l = `${a}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${i}.svg`;
  return /* @__PURE__ */ n(
    "img",
    {
      alt: t,
      className: d({
        addPrefix: ["flag-emoji"],
        rawClassNames: [c]
      }),
      src: l,
      width: o,
      height: o,
      draggable: !1,
      "data-country": t,
      loading: s ? void 0 : "lazy",
      ...e
    }
  );
};
export {
  j as FlagEmoji
};
